import { create } from "zustand";
import store from "store2";
import isNil from "lodash.isnil";

export const AUTH_STORAGE_KEY = "exibra/auth-token";
export const REDIRECT_URL_STORAGE_KEY = "exibra/redirect-url";

export interface AuthState {
    /** The token */
    token?: string;
    /** If the auth is currently invalid */
    authInvalid?: boolean;
    /** URL to redirect to after successful authentication */
    redirectUrl?: string;
    /** If a login attempt is ongoing */
    refreshAttempt?: boolean;
    /** If the auth is currently loading */
    isLoading?: boolean;
}

export interface AuthActions {
    /** Sets the auth token */
    setAuthToken: (token: string) => void;
    /** Expires the token */
    expireToken: () => void;
    /** Returns true if the app is currently authenticated */
    isAuthenticated: () => boolean;
    /** Sets the redirect URL */
    setRedirectUrl: (url: string) => void;
    /** Clears the redirect URL */
    clearRedirectUrl: () => void;
}

export const useAuthStore = create<AuthState & AuthActions>()((set, get) => ({
    token: store.get(AUTH_STORAGE_KEY),
    redirectUrl: store.get(REDIRECT_URL_STORAGE_KEY),
    userRoles: [],
    refreshAttempt: false,
    isLoading: false,
    expireToken: () => {
        set({ token: undefined, authInvalid: true });
        store.remove(AUTH_STORAGE_KEY);
    },
    setAuthToken: (val) => {
        store.set(AUTH_STORAGE_KEY, val);
        set({ token: val, authInvalid: false });
    },
    isAuthenticated: () => {
        return !isNil(get().token);
    },
    setRedirectUrl: (url) => {
        store.set(REDIRECT_URL_STORAGE_KEY, url);
        set({ redirectUrl: url });
    },
    clearRedirectUrl: () => {
        store.remove(REDIRECT_URL_STORAGE_KEY);
        set({ redirectUrl: undefined });
    },
}));
